import { render, staticRenderFns } from "./surface_post_comments.vue?vue&type=template&id=4889fc9a&scoped=true&"
import script from "./surface_post_comments.vue?vue&type=script&lang=ts&"
export * from "./surface_post_comments.vue?vue&type=script&lang=ts&"
import style0 from "./surface_post_comments.vue?vue&type=style&index=0&id=4889fc9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4889fc9a",
  null
  
)

export default component.exports